import styled from 'styled-components';

export const StatsBannerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 30px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const StatsBannerCard = styled.div`
  background: linear-gradient(135deg, #2f3d48 0%, #1d2933 100%);
  border-radius: 16px;
  padding: 24px 28px;
  color: #ffffff;
`;

export const StatsBannerNumber = styled.div`
  font-size: 56px;
  font-weight: 700;
  line-height: 1;
  color: #17c981;
  margin-bottom: 12px;
`;

export const StatsBannerHeadline = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
  margin-bottom: 6px;
`;

export const StatsBannerSubtext = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: #ffffff;
  line-height: 1.4;
`;
